import { UseMutationOptions, useMutation } from "react-query";

import { AxiosRequestConfig, AxiosError } from "axios";
import { TreeNode } from "ui/components/AccountPlanTree";
import http from "infra/http";
import { queryClient } from "infra/packages/react-query";
import { showErrorAxios } from "infra/helpers/alerta";
import { CategoriaFinanceiraItem } from "features/condominio/hooks/useListFinancialCategory";
import { useInvalidateQuery } from "infra/packages/react-query/index";
import { useDetalhesHeader } from "components/Layout/Header/hooks/useDetalhesHeader";

const changeNode = (root: TreeNode[], item: TreeNode, value: TreeNode) => {
  return root?.map?.(({ key, id, nome, items = [], ...rest }: TreeNode) => {
    const node: TreeNode = { ...rest, key, id, nome };
    if ((key && key === item.key) || (id && id === item.id)) {
      node.key = value.key;
      node.id = value.id;
      node.nome = value.nome;
      node.operacao = value.operacao;
      node.podeClassificarConta = value.podeClassificarConta;
      node.codigoIntegracao = value.codigoIntegracao;
      node.ativo = value.ativo;
      node.centroDeCusto = value.centroDeCusto;
      node.centroDeCustoId = value.centroDeCustoId;
    }
    if (items) node.items = changeNode(items, item, value);
    return node;
  });
};

export default function useUpdateFinancialCategory(tenant?: string) {
  const { data: passosCadastro } = useDetalhesHeader();
  const { doInvalidateQueryWithStringKey } = useInvalidateQuery();
  const config: AxiosRequestConfig = {};
  const options: UseMutationOptions<
    CategoriaFinanceiraItem,
    AxiosError,
    Partial<CategoriaFinanceiraItem>,
    any
  > = {
    onSuccess: async (
      data: Partial<CategoriaFinanceiraItem>,
      variables: any
    ) => {
      // Cancela outras requisições
      await queryClient.cancelQueries("/v1/categoria-financeira");
      // Guarda o valor anterior
      const previous = queryClient.getQueryData<any>(
        "/v1/categoria-financeira"
      );
      // adiciona o nó e retorna o novo valor
      const updatedValue = changeNode(previous, variables, {
        ...variables,
        id: data.id,
        centroDeCustoId: data.centroDeCustoId,
        centroDeCusto: data.centroDeCusto ?? null,
      });
      // Atualiza o novo valor
      if (previous) {
        queryClient.setQueryData("/v1/categoria-financeira", updatedValue);
      }
      if (passosCadastro?.some((passo) => passo.porcentagemConcluido < 100)) {
        doInvalidateQueryWithStringKey("/v1/tenants/passos-cadastro");
      }
    },
    onError: (err) => {
      showErrorAxios(err);
    },
  };
  return useMutation(
    "UpdateCategoria",
    async (body: Partial<CategoriaFinanceiraItem>) => {
      const request = body?.id ? http.put : http.post;
      const url: string = body?.id
        ? `/v1/categoria-financeira/${body.id}`
        : `/v1/categoria-financeira?tenant=${tenant ?? ""}`;

      const { data } = await request(url, body, config);
      return data;
    },
    options
  );
}
